/*
 * swatch-colors.js
 * Table partagee nom de couleur -> valeur CSS, pour les pastilles de variantes.
 *
 * Expose window.peeksmeSwatchColor(nom) et window.peeksmeSwatchColorMap.
 *
 * Source unique : sections/product-custom.liquid, product-featured.liquid et
 * pack-builder.liquid consomment tous cette table. Ajouter une couleur ici la
 * rend disponible partout.
 */
(function () {
  'use strict';

  /* Deux sections peuvent inserer ce script sur la meme page (page produit :
     product-custom + product-featured). Une seule execution suffit. */
  if (typeof window.peeksmeSwatchColor === 'function') return;

var COLOR_MAP = {
    /* Français */
    'rouge': '#e74c3c', 'rouge foncé': '#c0392b', 'rouge vif': '#ff2020',
    'blanc': '#ffffff', 'blanc cassé': '#f8f5f0',
    'noir': '#1a1a1a',
    'bleu': '#3498db', 'bleu marine': '#001f3f', 'bleu ciel': '#87ceeb',
    'bleu clair': '#add8e6', 'bleu nuit': '#0b1d51', 'bleu roi': '#4169e1',
    'vert': '#5BBFB5', 'vert kaki': '#6b8e23', 'vert forêt': '#228b22',
    'vert vif': '#27ae60', 'vert menthe': '#5BBFB5', 'vert olive': '#808000', 'vert sauge': '#8fbc8f',
    'jaune': '#f1c40f', 'jaune moutarde': '#d4ac0d', 'jaune citron': '#fff44f',
    'orange': '#e67e22', 'orange brûlé': '#cc5500',
    'violet': '#8e44ad', 'mauve': '#dda0dd', 'lilas': '#c8a2c8', 'lavande': '#e6e6fa',
    'rose': '#ff69b4', 'rose pâle': '#ffb6c1', 'rose saumon': '#fa8072', 'rose poudré': '#d4a0a0',
    'gris': '#8e9eab', 'gris clair': '#d5dbdb', 'gris foncé': '#566573', 'gris perle': '#e8e8e8',
    'beige': '#f5f0e8', 'sable': '#c2b280', 'écru': '#f2e8d5', 'ivoire': '#fffff0',
    'crème': '#fffdd0', 'vanille': '#f3e5ab',
    'marron': '#8b4513', 'camel': '#c19a6b', 'noisette': '#a0522d', 'chocolat': '#5c3317',
    'bordeaux': '#722f37', 'burgundy': '#722f37',
    'turquoise': '#5BBFB5', 'canard': '#048a81', 'pétrole': '#005f73', 'menthe': '#5BBFB5',
    'corail': '#ff6b6b', 'pêche': '#ffcba4',
    'doré': '#ffd700', 'or': '#ffd700', 'argent': '#c0c0c0',
    'marine': '#001f3f', 'taupe': '#483c32', 'kaki': '#c3b091', 'ocre': '#cc7722',
    /* English */
    'red': '#e74c3c', 'dark red': '#c0392b', 'bright red': '#ff2020',
    'white': '#ffffff', 'off-white': '#f8f5f0',
    'black': '#1a1a1a',
    'blue': '#3498db', 'navy': '#001f3f', 'navy blue': '#001f3f',
    'sky blue': '#87ceeb', 'light blue': '#add8e6', 'royal blue': '#4169e1',
    'green': '#5BBFB5', 'bright green': '#27ae60', 'olive': '#808000', 'forest green': '#228b22',
    'mint': '#5BBFB5', 'sage': '#8fbc8f', 'teal': '#5BBFB5',
    'yellow': '#f1c40f', 'mustard': '#d4ac0d', 'lemon': '#fff44f',
    'orange': '#e67e22', 'burnt orange': '#cc5500',
    'purple': '#8e44ad', 'mauve': '#dda0dd', 'lilac': '#c8a2c8', 'lavender': '#e6e6fa',
    'pink': '#ff69b4', 'light pink': '#ffb6c1', 'salmon': '#fa8072', 'dusty rose': '#d4a0a0',
    'grey': '#8e9eab', 'gray': '#8e9eab', 'light grey': '#d5dbdb', 'dark grey': '#566573',
    'pearl': '#e8e8e8', 'silver': '#c0c0c0',
    'beige': '#f5f0e8', 'sand': '#c2b280', 'ecru': '#f2e8d5', 'ivory': '#fffff0',
    'cream': '#fffdd0', 'vanilla': '#f3e5ab',
    'brown': '#8b4513', 'camel': '#c19a6b', 'hazel': '#a0522d', 'chocolate': '#5c3317',
    'petrol': '#005f73',
    'coral': '#ff6b6b', 'peach': '#ffcba4',
    'gold': '#ffd700', 'taupe': '#483c32', 'khaki': '#c3b091'
  };
  /* Resolution : correspondance exacte, puis partielle, puis on tente le nom
     tel quel comme couleur CSS (« tomato », « #ff0000 »…). */
  function resolve(colorName) {
    var key = (colorName || '').toLowerCase().trim();
    if (!key) return '#cccccc';
    if (COLOR_MAP[key]) return COLOR_MAP[key];

    var keys = Object.keys(COLOR_MAP);
    for (var i = 0; i < keys.length; i++) {
      if (key.indexOf(keys[i]) !== -1 || keys[i].indexOf(key) !== -1) {
        return COLOR_MAP[keys[i]];
      }
    }
    return key;
  }

  window.peeksmeSwatchColorMap = COLOR_MAP;
  window.peeksmeSwatchColor = resolve;
})();
